import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Periodo } from '../../../app/domains/periodo';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Cliente } from '../../../app/domains/cliente';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { Result } from '../../domains/result';

@Component({
  selector: 'app-periodo-edit',
  templateUrl: './periodo-edit.component.html',
  styleUrls: ['./periodo-edit.component.css'],
  standalone: false,
})
export class periodoEditComponent implements OnInit {
  form: UntypedFormGroup = null as any;
  enviando = false;

  @Input() periodo: Periodo = null as any;
  @Input() selectedCliente: Cliente = null as any;
  @Input() editMode: boolean = false;
  displayperiodo: boolean = false;

  @Output()
  updateList = new EventEmitter();

  filiais: any[] = [];

  motivos: { descricao: string; id: number }[] = [
    {
      descricao: 'Serviço não prestado',
      id: 2,
    },
    {
      descricao: 'Duplicidade da nota',
      id: 4,
    },
  ];

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    //obtem todos os períodos sem filtros
    this.http
      .get<Result<[]>>(environment.apiUrl + '/branch')
      .subscribe((res) => {
        this.filiais = res.data;
      });
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      id: [],
      tipo: ['', Validators.required],
      data_pagamento: [''],
      maximo_horas: [0],
      descricao: ['', Validators.required],
      data_inicio: ['', Validators.required],
      data_fim: [''],
      valor_hora: [0, Validators.required],
      porcentagem_imposto: [undefined],
      data_emissao_nota: [undefined],
      solicitante: [false],
      data_solicitacao: [false],
      envia_relatorio: [false],
      checa_hora: [true],
      informa_chamado: [true],
      mostra_abonos: [true],
      gera_boleto: [false],
      gera_nfse: [false],
      cancela_nfse: [false],
      motivo_cancelamento: [],
      envia_email: [false],
      cliente_id: [0],
      filial_id: [undefined],
      nome_filial: [''],
      nosso_numero: [''],
      dias_liberados: [8],
    });
    this.form.get('maximo_horas')?.disable();
    this.form.get('data_emissao_nota');
    this.form.get('data_fim')?.disable();
    this.form.get('nosso_numero')?.disable();
    this.form.get('porcentagem_imposto')?.disable();
  }

  updateForm(periodo: Periodo) {
    this.createForm();
    this.form.setValue({
      id: periodo.id,
      data_inicio: new Date(periodo.data_inicio),
      data_fim: periodo.data_fim ? new Date(periodo.data_fim) : '',
      descricao: periodo.descricao,
      tipo: periodo.tipo,
      maximo_horas: periodo.maximo_horas,
      valor_hora: periodo.valor_hora,
      porcentagem_imposto: periodo.porcentagem_imposto,
      cliente_id: periodo.cliente_id,
      data_pagamento: periodo.data_pagamento
        ? new Date(periodo.data_pagamento)
        : '',
      data_emissao_nota: periodo.data_emissao_nota
        ? new Date(periodo.data_emissao_nota)
        : '',
      dias_liberados: periodo.dias_liberados,
      nosso_numero: periodo.nosso_numero,
      filial_id: periodo.filial_id,
      solicitante: periodo.solicitante,
      data_solicitacao: periodo.data_solicitacao,
      envia_relatorio: periodo.envia_relatorio,
      checa_hora: periodo.checa_hora,
      informa_chamado: periodo.informa_chamado,
      mostra_abonos: periodo.mostra_abonos,
      nome_filial: periodo.nome_filial ? periodo.nome_filial : '',
      envia_email: false,
      gera_nfse: false,
      gera_boleto: false,
      cancela_nfse: false,
      motivo_cancelamento: '',
    });
    this.form.get('data_emissao_nota')?.disable();
    this.onChangeTipo();
    if (periodo.status != 'Aberto' || this.form.get('data_fim')?.value) {
      this.form.disable();
      this.form.get('envia_email')?.enable();
      this.form.get('gera_nfse')?.enable();
      this.form.get('gera_boleto')?.enable();
    } else {
      this.form.get('envia_email')?.disable();
      this.form.get('gera_nfse')?.disable();
      this.form.get('gera_boleto')?.disable();
    }

    // se já tem nota emitida não deixa editar a filial
    if (periodo.numero_nfse) {
      this.form.get('filial_id')?.disable();
      this.form.get('cancela_nfse')?.enable();
    } else {
      this.form.get('filial_id')?.enable();
      this.form.get('cancela_nfse')?.disable();
    }
    this.form.get('motivo_cancelamento')?.disable();

    //se ja tem numero de boleto não deixa editar data de pagamento
    if (periodo.nosso_numero) {
      this.form.get('data_pagamento')?.disable();
    } else {
      this.form.get('data_pagamento')?.enable();
    }

    //  se não tem atendimentos não deixa fechar
    if (periodo.quantidade_atendimentos > 0) {
      this.form.get('data_fim')?.enable();
    } else {
      this.form.get('data_fim')?.disable();
    }
    this.form.get('porcentagem_imposto')?.disable();
  }

  onDialogHide() {
    this.periodo = null as any;
  }

  onSubmit() {
    const tempperiodo = <Periodo>{};

    // se marca para gerar nfse precisa selecionar a filial
    if (this.form.getRawValue().gera_nfse) {
      if (this.form.getRawValue().filial_id === undefined) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Selecione uma filial para gerar a NFSe',
        });
        return;
      }
    }
    // se marca para gerar boleto precisa gerar nfse
    if (this.form.getRawValue().gera_boleto) {
      if (!this.form.getRawValue().gera_nfse) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Selecione a opção de gerar NFSe para gerar o boleto',
        });
        return;
      }
    }
    // se marcar para enviar e-mail precisa ou gerar nfse ou  ja ter o numero da nfse
    if (this.form.getRawValue().envia_email) {
      if (
        !this.form.getRawValue().gera_nfse &&
        (this.form.getRawValue().data_emissao_nota === '' ||
          this.form.getRawValue().data_emissao_nota === undefined)
      ) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail:
            'Selecione a opção de gerar NFSe ou preencha o número da NFSe para enviar o e-mail',
        });
        return;
      }
    }

    tempperiodo.tipo = this.form.getRawValue().tipo
      ? this.form.getRawValue().tipo
      : 'Aberto';
    tempperiodo.maximo_horas = this.form.getRawValue().maximo_horas;
    tempperiodo.data_pagamento = this.form.getRawValue().data_pagamento;
    tempperiodo.descricao = this.form.getRawValue().descricao;
    tempperiodo.data_inicio = this.form.getRawValue().data_inicio;
    tempperiodo.data_fim =
      this.form.getRawValue().data_fim === ''
        ? null
        : this.form.getRawValue().data_fim;
    tempperiodo.valor_hora = +this.form.getRawValue().valor_hora;
    tempperiodo.porcentagem_imposto =
      +this.form.getRawValue().porcentagem_imposto;
    tempperiodo.cliente_id = this.selectedCliente?.id as any;
    tempperiodo.solicitante = this.form.getRawValue().solicitante;
    tempperiodo.dias_liberados = this.form.getRawValue().dias_liberados;
    tempperiodo.data_solicitacao = this.form.getRawValue().data_solicitacao;
    tempperiodo.envia_relatorio = this.form.getRawValue().envia_relatorio;
    tempperiodo.checa_hora = this.form.getRawValue().checa_hora;
    tempperiodo.informa_chamado = this.form.getRawValue().informa_chamado;
    tempperiodo.mostra_abonos = this.form.getRawValue().mostra_abonos;
    tempperiodo.filial_id = this.form.getRawValue().filial_id;
    tempperiodo.nosso_numero = this.form.getRawValue().nosso_numero;
    tempperiodo.gera_nfse = this.form.getRawValue().gera_nfse;
    tempperiodo.envia_email = this.form.getRawValue().envia_email;
    tempperiodo.gera_boleto = this.form.getRawValue().gera_boleto;
    tempperiodo.cancela_nfse = this.form.getRawValue().cancela_nfse;
    tempperiodo.motivo_cancelamento =
      this.form.getRawValue().motivo_cancelamento;
    tempperiodo.data_emissao_nota =
      this.form.getRawValue().data_emissao_nota === ''
        ? undefined
        : this.form.getRawValue().data_emissao_nota;

    let url = environment.apiUrl + '/period';
    let metodo;
    if (this.editMode) {
      tempperiodo.id = +this.form.getRawValue().id;
      metodo = this.http.put(url + '/' + tempperiodo.id, tempperiodo);
    } else {
      metodo = this.http.post(url, tempperiodo);
    }

    this.enviando = true;
    metodo.subscribe(
      () => {
        this.enviando = false;
        this.updateList.emit(this.selectedCliente.id);
        this.hide();
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Seu periodo foi salvo.',
        });
      },
      (error) => {
        this.enviando = false;
        console.log(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Falha ao salvar',
          detail:
            error.error && error.error.message
              ? error.error.message
              : 'Erro ao Enviar!',
        });
      }
    );
  }

  onDelete() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o periodo?',
      accept: () => {
        this.enviando = true;
        const url =
          environment.apiUrl + '/period/' + this.form.getRawValue().id;
        this.http.delete(url).subscribe(
          () => {
            this.enviando = false;
            this.updateList.emit(this.selectedCliente.id);
            this.hide();
            this.messageService.add({
              severity: 'success',
              summary: 'Exclusão efetuada com sucesso',
              detail: 'Sua exclusão foi realizada.',
            });
          },
          (error) => {
            this.enviando = false;
            console.log(error);

            this.messageService.add({
              severity: 'error',
              summary: 'Falha na exclusão',
              detail: 'Via MessageService',
            });
          }
        );
      },
    });
  }

  onRecalcula() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja recalcular o periodo?',
      accept: () => {
        this.enviando = true;
        const url =
          environment.apiUrl + '/period/recalc/' + this.form.getRawValue().id;
        this.http.get(url).subscribe(
          () => {
            this.enviando = false;
            this.updateList.emit(this.selectedCliente.id);
            this.messageService.add({
              severity: 'success',
              summary: 'Recálculo efetuada com sucesso',
              detail: 'Sua recálculo foi realizada.',
            });
          },
          (error) => {
            this.enviando = false;
            console.log(error);

            this.messageService.add({
              severity: 'error',
              summary: 'Falha no recálculo',
              detail: 'Via MessageService',
            });
          }
        );
      },
    });
  }

  hide() {
    this.displayperiodo = false;
  }

  onChangeTipo() {
    if (this.form.getRawValue().tipo === 'Fechado') {
      this.form.get('maximo_horas')?.setValidators([Validators.required]);
      this.form.get('maximo_horas')?.enable();
    } else {
      this.form.get('maximo_horas')?.clearValidators();
      this.form.get('maximo_horas')?.disable();
      this.form.get('maximo_horas')?.setValue(0);
    }
    this.form.updateValueAndValidity();
  }

  atualizaCancelamento() {
    if (this.form.getRawValue().cancela_nfse) {
      this.form
        .get('motivo_cancelamento')
        ?.setValidators([Validators.required]);
      this.form.get('motivo_cancelamento')?.enable();
    } else {
      this.form.get('motivo_cancelamento')?.clearValidators();
      this.form.get('motivo_cancelamento')?.disable();
      this.form.get('motivo_cancelamento')?.setValue(null);
    }
  }
}
